<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class=" section" v-on:click="goTo('/history')">Pedidos</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Información</a>
  </div>
  <h1 v-if="parcel" class="ui header"><img class="ui image" src="../../assets/parcels.png">
    <div class="content">Pedido {{ from }}</div>
  </h1>
  <h4 class="ui dividing header">Datos</h4>
  <div v-if="!parcel" class="ui active centered inline loader"></div>
  <div v-if="parcel" class="ui stackable three column divided grid container">
    <div class="row">
      <div class="column">
        <!-- <h4 class="ui dividing header">Pedido</h4> -->
        <div class="form ui">
          <div class="field">
            <label>Referencia</label>
            <input type="text" v-model="parcel.name" readonly>
          </div>
          <div class="field">
            <label>Teléfono</label>
            <input type="text" v-model="parcel.phone" readonly>
          </div>
          <div class="field">
            <label>Fecha introducción</label>
            <input type="text" v-model="parcel.in_apt_date" readonly>
          </div>
          <div class="field">
            <label>Fecha salida</label>
            <input type="text" v-model="parcel.out_apt_date" readonly>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="form ui">
           <div class="field">
            <label>Estado</label>
            <input type="text" v-model="parcel.status2" readonly>
          </div>
          <div v-if="parcel.open_code" class="field">
            <label>Código de recogida</label>
            <input type="text" v-model="parcel.open_code" readonly>
          </div>
          <div class="field">
            <label>Nº de slots</label>
            <input type="text" v-model="slot_sizes.length" readonly>
          </div>
          <div v-if="slot_sizes.length===1" class="field">
            <label>Tamaño de slots</label>
            <input type="text" v-model="parcel.pack_size" readonly>
          </div>
          <div v-if="slot_sizes.length>1" class="field">
            <label>Tamaños de slots</label>
            <sui-table compact>
              <sui-table-body>
                <sui-table-row v-for="size in slot_sizes" :key="size.n">
                  <sui-table-cell>{{ size.slot_size }}</sui-table-cell>
                </sui-table-row>
              </sui-table-body>
            </sui-table>
          </div>
            
        </div>
      </div>
      <div class="column">
        <!-- <h4 v-if="parcel.pay_code" class="ui dividing header">Pago vía Redsys</h4>
        <h4 v-if="!parcel.pay_code" class="ui dividing header">Pago vía tienda</h4> -->
        <div class="form ui">
          <div class="field">
            <label>Vía pago</label>
            <input type="text" v-model="parcel.via_pago" readonly>
          </div>
          <div class="field">
            <label>Importe</label>
            <div class="ui right labeled input">
              <input type="text" v-model="parcel.amount" readonly>
              <div class="ui basic label">
                €
              </div>
            </div>
          </div>
          <div v-if="parcel.via_pago==='redsys'" class="field">
            <label>Código operación</label>
            <input type="text" v-model="parcel.pay_code" readonly>
          </div>
          <div v-if="parcel.via_pago==='redsys'" class="field">
            <label>Fecha petición de pago</label>
            <input type="text" v-model="parcel.paygold_date" readonly>
          </div>
          <div v-if="parcel.via_pago==='redsys'" class="field">
            <label>Fecha pago</label>
            <input type="text" v-model="parcel.pay_date" readonly>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="parcel" class="ui stackable one column divided grid container">
    <div class="row">
      <div class="column">
        <h4 class="ui dividing header">Notificaciones al usuario</h4>
        <div class="ui relaxed divided list">
          <div class="item" v-for="sms in parcel.smslist" :key="sms.id">
            <img class="ui mini image" src="../../assets/in-apt.png">
            <div class="content">
              <span class="header">{{sms.SmsStatus.created}}</span>
              <div class="description"><b>{{sms.SmsStatus.from_name}}:</b> <span class="txiki">{{sms.SmsStatus.text}}</span></div>
            </div>
            <div class="right floated content">
              <span class="header">{{sms.SmsStatus.to_phone}}</span>
              <div class="description">{{sms.SmsStatus.status}}</div>
            </div>
          </div>
        </div>
        <div v-if="parcel.status=='in-apt'" class="ui button green" v-on:click="resendSms(parcel.parcel_id,parcel.phone)">Re-enviar</div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'shParcelInfo',
  props: ['from', 'id'],
  role: null,
  data() {
    return {
      parcel: null,
      // multiorders: null,
      slot_sizes: [],
      pagoVia: null,
      columns: [{
        label: 'Nº bulto',
        field: 'mutiorder_count',
        width: '65px'
      },
      {
        label: 'Tamaño',
        field: 'slot_size',
        width: '90px'
      }],
      rows: []
    }
  },
  created() {
    this.role = JSON.parse(localStorage.admin).role;
    this.getParcelInfo();
  },
  methods: {
    getParcelInfo() {
      hapiickApi().post('/v3/shipments/get-shipment', {
        admin_id: JSON.parse(localStorage.admin).id,
        from: this.from,
        id: this.id,
        withMultiorders: true
      })
      .then(request => {
        // console.log(request)
        this.parcelInfo(request)
      })
      .catch(
        (request) =>  {
          this.$swal({
            type: 'error',
            title: 'Error',
            text: 'Error getting parcel info'
          });
          console.log('error getting parcels: ' + request)
        }
      )
    },
    goTo(where) {
      this.$router.push(where)
    },
    parcelInfo(req) {
      // console.log(req)
      const { data } = req.data
      this.parcel = {... data.parcel}
      this.parcel['status2'] = (this.parcel.status in this.$sh_status) ? this.$sh_status[this.parcel.status] : this.parcel.status
      if (this.parcel.status === 'delivered' || this.parcel.status === 'to-term') {
        this.parcel['out_apt_date'] = this.parcel.lastUpdate
      }
      this.parcel.via_pago = (this.parcel.pay_code) ? 'redsys' : 'tienda'
      this.slot_sizes = [{
            n: 1,
            slot_size: this.parcel.pack_size
          }]
      if ('multiorders' in data) {
        if (data.multiorders.length !== 0) {
          const multiorders = data.multiorders
          // console.log(multiorders)
          for (const index in multiorders) {
            // console.log(index)
            this.slot_sizes.push({
              n: parseInt(index) + 1,
              slot_size: multiorders[index]['pack_size']
            })
          }
        }
      }
      // this.phone = this.parcel.user.phone
    },
    resendSms(id, phone) {
      let provider_id = this.parcel.smslist[0].SmsStatus.provider_id
      hapiickApi().post('/v3/shipments/sms/resend', {
        admin_id: JSON.parse(localStorage.admin).id,
        parcel_id: id,
        provider_id: provider_id,
        phone: phone,
        from: this.parcel.from,
        apt_id: this.parcel.apt_id,
      })
      .then(request => this.getParcelInfo())
      .catch(() => console.log('error getting parcels'))
    },
    editPhoneClick() {
      document.getElementById("editPhone").style.display = "none";
      document.getElementById("editPhoneOK").style.display = "block";
      document.getElementById('inputEditPhone').removeAttribute('readonly');
      document.getElementById('inputEditPhone').focus()
    },
    editPhoneOKClick() {
      //  this.parcel.user.phone=this.phone
      document.getElementById("editPhone").style.display = "block";
      document.getElementById("editPhoneOK").style.display = "none";
      document.getElementById('inputEditPhone').readOnly = true;

      hapiickApi().post('/v2/shipments/edit-phone', {
        // admin_id: JSON.parse(localStorage.admin).id,
        // parcel_id: this.parcel.parcel_id,
        // phone: this.parcel.phone
        admin_id: JSON.parse(localStorage.admin).id,
        user: this.from,
        id: this.id,
        phone: this.parcel.phone
      })
      .then(request => this.getParcelInfo())
      .catch(() => console.log('error getting parcels'))
    }
  }
}
</script>

<style scoped>
.txiki {
  font-size: 12px;
}
#editPhoneOK {
  display: none;
}
.table{
  margin: 0px!important
}
</style>



// WEBPACK FOOTER //
// src/components/Shophapiick/shParcelInfo.vue